import { render, staticRenderFns } from "./ProcessPeople.vue?vue&type=template&id=201a5f42&scoped=true&"
import script from "./ProcessPeople.vue?vue&type=script&lang=js&"
export * from "./ProcessPeople.vue?vue&type=script&lang=js&"
import style0 from "./ProcessPeople.vue?vue&type=style&index=0&id=201a5f42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a5f42",
  null
  
)

export default component.exports